export default __webpack_public_path__ + "static/media/logo.c9af0761.png";